import classNames from "classnames";
import styles from "./FeaturedIcon.module.css";
import { IconComponentType } from "../Icon/Icon";

function FeaturedIcon({
  IconComponent,
  className,
}: {
  IconComponent: IconComponentType;
  className?: string;
}) {
  return (
    <IconComponent
      className={classNames(styles.icon, className)}
      size="large"
    />
  );
}

export default FeaturedIcon;
